import moment from 'moment'
import configuracoesRepository from '../../Configuracoes/ConfiguracoesRepository'
import { FonteLiberacaoEnum, StatusEnum } from '../components'

export async function canPrintProtocolo({
  status,
  dataTermino,
  fonteLiberacao
}) {
  const resposeDiasLimite = await configuracoesRepository.getOne({
    id: 'DIAS_LIMITE_RENOVACAO'
  })

  const valor = resposeDiasLimite.data?.valor
  const diasRenovacao = Number(valor) || 180

  const isDataExpirada =
    moment().diff(moment(dataTermino), 'days') <= +diasRenovacao

  const isStatusLiberado = [
    StatusEnum.LIBERADA,
    StatusEnum.LIBERADAAUTOMATICAMENTE,
    StatusEnum.LIBERADACOMPENDENCIA,
    StatusEnum.LIBERADAGESTOR
  ].includes(status)

  const isNaoRecomendada = fonteLiberacao === FonteLiberacaoEnum.NAO_RECOMENDAR

  return dataTermino && isStatusLiberado && isDataExpirada && !isNaoRecomendada
}
